const FLOOR = "2026-10-01";

/** Honest coverage note: WhatsApp media/messages were imported into Strata from Oct 1, 2026 onward. */
export default function CoverageNotice({ from, to }) {
  if (!from || !to || from >= FLOOR) return null;
  const whole = to < FLOOR;
  return (
    <div className="rounded-lg border border-[#efe4b0]/60 bg-[#efe4b0]/10 px-3 py-2 text-xs text-[#b59a2a]" data-testid="dl-coverage-notice">
      {whole
        ? "WhatsApp data before October 1, 2026 has not been imported into Strata. Please review the WhatsApp chat directly for earlier records."
        : "Partial coverage: WhatsApp data before October 1, 2026 has not been imported into Strata. Records shown start Oct 1, 2026 (plus any older items saved earlier) — check the WhatsApp chat directly for earlier days."}
    </div>
  );
}
